import YaslandirmaReport from "./YaslandirmaReport";

const CONFIG = {
  sql: `
SELECT
  n.ISIM, n.KOD, n.YIL, n.AY, n.GUN, ABS(SUM(n.TUTAR)) AS TUTAR,
  MAX(c.BELGE_NO) AS BELGE_NO,
  MAX(c.TARIH) AS FATURA_TARIHI,
  MAX(c.VADE_TARIHI) AS VADE_TARIHI
FROM EMW_NAKITAKIS n
LEFT JOIN TBLCAHAR c ON n.INCKEYNO = c.INC_KEY_NUMBER
WHERE n.TIP = '103-Satici Alacak'
GROUP BY n.ISIM, n.KOD, n.YIL, n.AY, n.GUN
ORDER BY n.YIL, n.AY, n.ISIM
`.trim(),
  procedure:   "_SATICI_YASLANDIRMA",
  title:       "Satıcı Alacak Raporu",
  icon:        "🏭",
  entityLabel: "Satıcı",
  tabLabel:    "Satıcı Bazlı",
};

export default function SaticiAlacakReport() {
  return <YaslandirmaReport config={CONFIG} />;
}
